import { createContext, useContext } from 'react';

/**
 * Sur certaines fiches produit, le point de montage du widget Avis Vérifiés / Skeepers
 * est déplacé dans le bandeau SAV (au lieu du footer) pour éviter deux éléments avec le même id.
 */
const defaultValue = {
  mountWidgetInListingAfterSales: false,
};

export const SkeepersAvisVerifiesListingContext = createContext(defaultValue);

export const useSkeepersAvisVerifiesListingPlacement = () =>
  useContext(SkeepersAvisVerifiesListingContext);
